import React from "react";
function PackagesHeader() {
  return (
    <div className="display-flex App PackagesHeader scaffold">
      <h2>
        <span className="PackagesHeaderbg">OUR PACKAGES</span>
      </h2>
    </div>
  );
}
export default PackagesHeader;
